/* eslint-disable no-underscore-dangle, @typescript-eslint/naming-convention */
import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";
import { LuigisboxHitItem } from "./luigisboxAutocompleteTypes";

declare global {
    interface Window {
        _lbcq: unknown[];
        Luigis?: {
            Scan?: (...argument0: string[]) => void;
        };
    }
}

interface EventItem {
    title: string;
    type: "item" | "category";
    url: string;
    position: number;
    price?: number;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface LuigisboxOrderFinishedProduct {
    title: string;
    url: string;
    count: number;
    total_price: number;
    was_discounted: boolean;
    was_volume_discounted: boolean;
}
/* eslint-enable @typescript-eslint/naming-convention */

export default new class LuigisboxAnanyticsService {
    private trackerId: string | undefined;

    public setTrackerId(trackerId: string): void {
        this.trackerId = trackerId;
    }

    public sendAutocompleteEvent(
        query: string,
        categories: LuigisboxHitItem<"category">[],
        products: LuigisboxHitItem<"item">[],
        categoryPath: string | undefined,
    ): void {
        let index = 1;
        const items: EventItem[] = [];

        categories.map((category: LuigisboxHitItem<"category">) => {
            items.push({
                title: category.attributes.title,
                type: "category",
                url: category.url,
                position: index++,
            });
        });

        products.map((product: LuigisboxHitItem<"item">) => {
            items.push({
                title: product.attributes.title,
                type: "item",
                url: product.url,
                position: index++,
                price: product.attributes.price,
            });
        });

        this.sendEventType({
            Autocomplete: {
                items: items,
                query: {
                    string: query,
                    filters: categoryPath === undefined
                        ? undefined
                        : {
                            category: categoryPath,
                        },
                },
            },
        });
    }

    /* eslint-disable camelcase */
    public sendAutocompleteClickEvent(productUrl: string): void {
        this.sendClickType({
            type: "click",
            resource_identifier: productUrl,
        });
    }

    public sendInsertToBasketEvent(productUrl: string): void {
        this.sendClickType({
            type: "buy",
            resource_identifier: productUrl,
        });
    }
    /* eslint-enable camelcase */

    public sendOrderFinishedEvent(products: LuigisboxOrderFinishedProduct[]): void {
        this.sendTransactionType(products);
    }

    /** eslint-disable @typescript-eslint/no-unsafe-assignment */
    public performLuigisboxAnalytics(): void {
        try {
            window._lbcq = [];
            window.Luigis = window.Luigis ?? {};
            window.Luigis.Scan = window.Luigis.Scan ?? function(a, r): void {
                window._lbcq.push([a, r]);
            };

            const toScanElements = ["#js-product-list-container", "#js-search-results-annotations"]
                .filter((selector) => document.querySelector<HTMLElement>(selector) !== null);

            // eslint-disable-next-line new-cap
            window.Luigis.Scan(...toScanElements);
        } catch {
            // We do not care about errors here
        }
    }

    private sendEventType(lists: Record<string, unknown>): void {
        this.sendAnalytics("event", { lists: lists });
    }

    private sendClickType(action: Record<string, unknown>): void {
        this.sendAnalytics("click", { action: action });
    }

    private sendTransactionType(items: LuigisboxOrderFinishedProduct[]): void {
        this.sendAnalytics("transaction", { items: items });
    }

    private sendAnalytics(type: "event" | "click" | "transaction", value: Record<string, unknown>): void {
        const clientId = Cookies.get("_lb");

        if (clientId === undefined || this.trackerId === undefined) {
            return;
        }

        try {
            /* eslint-disable camelcase */
            globalThis.navigator.sendBeacon(
                "https://api.luigisbox.com",
                JSON.stringify({
                    type: type,
                    tracker_id: this.trackerId,
                    client_id: Number.parseInt(clientId),
                    customer_id: undefined,
                    local_timestamp: Math.floor(Date.now() / 1000),
                    id: uuidv4(),
                    url: globalThis.location.origin + globalThis.location.pathname,
                    path: globalThis.location.pathname,
                    title: document.title,
                    ...value,
                }),
            );
            /* eslint-enable camelcase */
        } catch {
            // Ignore
        }
    }
}();
